import ButtonAnchor from "../basic/ButtonAnchor";

const BouncyBird = () => {
  return (
    <main>

      <section className="articles">

        <article className="left-image">

            <img src="/images/games/bouncybird_appicon.png" alt="Bouncy Bird Appicon" />
            <div>

              <h3 className="bouncy-bird">Bouncy Bird</h3>
              <p>
                My third game, Bouncy Bird, is a casual game where you have to guide the bird around the pipes, collecting gems. Gems can be used to buy upgrades, decreasing the bounciness of the bird and decreasing the speed, giving you more time! You can unlock different birds and themes, or buy the Cookie birds and themes!
              </p>
              <ButtonAnchor className="bouncy-bird" to="https://apps.apple.com/gb/app/bouncy-bird/id1602829255" text="Download for iOS" icon_path="/images/icons/appstore-icon.svg" alt_text="App Store Icon" />
            
            </div>
            
          </article>

        <article>
          <h3 className="bouncy-bird">Play it now in your browser!</h3>
          <p>
            Bouncy Bird can be played now in your browser! This version is not supported, and any minor bugs will not be fixed. Please still let me know (<a href="mailto:minibonzogames@gmail.com" className="bouncy-bird">minibonzogames@gmail.com</a>) and known bugs will be posted here.
          </p>
          <ButtonAnchor className="bouncy-bird" to="/play/bouncy-bird/index.html" text="Click here to play now!" icon_path="/images/icons/play-icon.svg" alt_text="Play Button" />
        </article>

      </section>

    </main>
  );
}

export default BouncyBird;